module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAKNJREFUWEftl7ENwzAMBE+Nd/ByWcOdi1TOGhkuHoOGU8hw0vArsXjVD+hxJIRTi4gJeAIPYGbs2YE3sLaI2IBlbJ+/219nsU8BUr/N9tLFyo6y5vIXW/pep7mYSMDERGCYmImpBNR83R2zj2mztI9pvOArivaxBLbrM5IID4nUfceG4EhcamIJSLeIiZmYSkDN190x+5g2S/uYxss+lufVfewAKhNcqe/U+rMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mo/open.png
// module id = 6/VC
// module chunks = 0